<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title41">
<p class="p-c">Dedication</p>
<p class="p-c">To my close family, without whose encouragement and support I would not have the time to embark upon projects such as these. Thanks to them for making sure that other areas of my life keep going.</p>
<p class="p-c">Also to Shaun and Zara for their unfailing support every time ‘Chris’ writes another one! Love to you both.</p>
<p class="p-blanc"> <br/></p>
<p class="p-c">Oh, and thanks to my wife for the title!</p>
<p class="p-blanc"> <br/></p>
<p class="p-blanc"> <br/></p>
<p class="p-blanc"> <br/></p>
<p class="p-blanc"> <br/></p>
<p class="p-blanc"> <br/></p>
<p class="p-blanc"> <br/></p>
<p class="p-blanc"> <br/></p>
<p class="p-blanc"> <br/></p>
<p class="p-blanc"> <br/></p>
<p class="p-blanc"> <br/></p>
<p class="p-c">. . . by the way, Dave – surely this time!</p></a></div><a id="title41">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781783408566_ded01.vue?37c90c48